import { render, staticRenderFns } from "./content-type-1.vue?vue&type=template&id=d20c5cfe&scoped=true&"
import script from "./content-type-1.vue?vue&type=script&lang=js&"
export * from "./content-type-1.vue?vue&type=script&lang=js&"
import style0 from "./content-type-1.vue?vue&type=style&index=0&id=d20c5cfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20c5cfe",
  null
  
)

export default component.exports